import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useMemo,
} from 'react';
import PropTypes from 'prop-types';

import { getOr } from 'lodash/fp';

export const ModalProviderContext = createContext();

export const useModalProviderContext = (modalName) => {
  const modalProviderContext = useContext(ModalProviderContext);
  const setIsOpen = useCallback(
    (value, extras = {}) => modalProviderContext.setModalOpen(modalName, value, extras),
    [modalProviderContext],
  );

  return {
    isOpen: !!getOr(false, `${modalName}.isOpen`, modalProviderContext),
    extras: getOr({}, `${modalName}.extras`, modalProviderContext),
    setIsOpen,
  };
};

const ModalProvider = ({ children }) => {
  const [modalState, setModalState] = useState({});
  const setModalOpen = useCallback((modalName, isOpen, extras = {}) => {
    setModalState({
      ...modalState,
      [modalName]: {
        isOpen,
        extras,
      },
    });
  }, [modalState]);

  const contextValue = useMemo(
    () => ({
      ...modalState,
      setModalOpen,
    }),
    [modalState, setModalOpen],
  );

  return (
    <ModalProviderContext.Provider value={contextValue}>
      {children}
    </ModalProviderContext.Provider>
  );
};
ModalProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
export default ModalProvider;

